import { render, staticRenderFns } from "./ChangePass.vue?vue&type=template&id=2b2f9d8d&scoped=true"
import script from "./ChangePass.vue?vue&type=script&lang=js"
export * from "./ChangePass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2f9d8d",
  null
  
)

export default component.exports